var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.75V21.625C8.5 22.1223 8.69754 22.5992 9.04917 22.9508C9.40081 23.3025 9.87772 23.5 10.375 23.5H21.625C22.1223 23.5 22.5992 23.3025 22.9508 22.9508C23.3025 22.5992 23.5 22.1223 23.5 21.625V19.75M12.25 12.25L16 8.5M16 8.5L19.75 12.25M16 8.5V19.75",
    stroke: "#424242",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.75V21.625C8.5 22.1223 8.69754 22.5992 9.04917 22.9508C9.40081 23.3025 9.87772 23.5 10.375 23.5H21.625C22.1223 23.5 22.5992 23.3025 22.9508 22.9508C23.3025 22.5992 23.5 22.1223 23.5 21.625V19.75M12.25 12.25L16 8.5M16 8.5L19.75 12.25M16 8.5V19.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.5f2088d24a23459a9165ffee6d143913.svg";
export { ForwardRef as ReactComponent };